<template>
  <vs-button
    ref="loadableButton"
    v-bind="$attrs"
    :class="effectiveClass"
    :color="color"
    :disabled="disabled || isLoading"
    v-on="listeners">
    <slot />
  </vs-button>
</template>

<script>
export default {
  name: "LoaderButton",

  inheritAttrs: false,

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    btnClass: {
      type: String,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isLoading: false,
  }),

  computed: {
    effectiveClass() {
      const width = this.btnClass ?? (this.compact ? "" : "sm:w-auto w-full")
      return `vs-con-loading__container${width ? ` ${width}` : ""}`
    },
    listeners() {
      return {
        ...this.$listeners,
        click: this.handleClick,
      }
    },
  },

  beforeDestroy() {
    if (this.isLoading) {
      this.closeLoading(this.$refs.loadableButton?.$el)
    }
  },

  methods: {
    closeLoading(container) {
      // $vs.loading.close() falls back to every body-level overlay when handed
      // anything that is not an Element, so an absent container must not reach it.
      if (container) {
        this.$vs.loading.close(container)
      }
    },

    async handleClick(e) {
      if (typeof this.$listeners.click !== "function") return

      let container

      try {
        container = this.$refs.loadableButton.$el

        this.isLoading = true
        this.$vs.loading({
          color: this.color,
          container,
          scale: 0.45,
        })

        await this.$listeners.click(e)
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        this.isLoading = false
        this.closeLoading(container)
      }
    },
  },
}
</script>
<style></style>
